export default "__VITE_ASSET__5st02Afe__"